export const projectBannerThumb = '/project-thumbs/banner-thumb.png'
